import React, { Component } from 'react';
import Powerbi from '../components/Powerbi';
import { Helmet } from 'react-helmet';
import * as pbi from 'powerbi-client';
import { connect } from 'react-redux';
import { requestACClientDashboardReport } from "../../../store/power-bi/PowerBiActions";
import { isExternalStakeholder } from '../../../store/current-user/CurrentUserSelectors';
import { hostTitle } from '../../../config/ui';

class ACClientDashboard extends Component {
  
  componentWillMount() {
    this.props.getACClientDashboardReport();
  };

  render() {
    const models = pbi.models;
    const { currentUser: { clients }, isExternalStakeholder, reports: { acClientDashboard: data } } = this.props;

    let currentClient = null;
    if (clients) {
      currentClient = clients.find(el => el.name === 'Anderson County');
    }

    return (
      <div id="reportContainers">
        <Helmet title={`Anderson County Client Dashboard – ${hostTitle()}`} />
        {isExternalStakeholder && (clients === undefined) && (
          <div className="well info">
            <h1 className="info text-center">You have no assigned clients to display reports.</h1>
          </div>
        )}
        {isExternalStakeholder && !currentClient && (
          <div className="well info">
            <h1 className="info text-center">Anderson County client not assigned to display the report.</h1>
          </div>
        )}
        {(data.accessToken && (currentClient || !isExternalStakeholder)) &&
          <Powerbi
            id={data.id}
            embedUrl={data.embedUrl}
            accessToken={data.accessToken}
            tokenType={models.TokenType.Embed}
            filterPaneEnabled={true}
            navContentPaneEnabled={true}
            width='100%'
            height='600px'
          />
        }
      </div>
    )
  }
}

//export default App
export default connect(
  state => ({
    reports: state.powerbi.reports,
    currentUser: state.currentUser.data,
    isExternalStakeholder: isExternalStakeholder(state),
  }),
  dispatch => ({
    getACClientDashboardReport: () => dispatch(requestACClientDashboardReport()),
  }),
)(ACClientDashboard);




// WEBPACK FOOTER //
// ./src/routes/reports-analytics/containers/ACClientDashboard.js